/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSurveyDto } from '../../models/create-survey-dto';
import { SurveyDto } from '../../models/survey-dto';

export interface SurveyControllerCreate$Params {
      body: CreateSurveyDto
}

export function surveyControllerCreate(http: HttpClient, rootUrl: string, params: SurveyControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SurveyDto>> {
  const rb = new RequestBuilder(rootUrl, surveyControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SurveyDto>;
    })
  );
}

surveyControllerCreate.PATH = '/api/survey';
